import Ajax from '../ajax';

export default {
  list: (data) => Ajax('get', 'couponActivity', data),
  get: (activityId) => Ajax('get', `couponActivity/${activityId}`),
  create: (data) => Ajax('post', 'couponActivity', data),
  update: (activityId, data) => Ajax('put', `couponActivity/${activityId}`, data),
  enable: (activityId) => Ajax('put', `couponActivity/${activityId}/enable`),
  disable: (activityId) => Ajax('put', `couponActivity/${activityId}/disable`),
};
